<div class="layout-container">
  
  <header class="page-header">
    <button class="icon-button" routerLink="/" title="Go Back">
      <img src="assets/arrow_back.svg" alt="Back" />
    </button>
    <h1 class="page-title">Legal Information</h1>
  </header>

  <main class="legal-content">
    <p class="last-updated">Last updated: 12 February 2026</p>

    <section id="privacy-policy">
      <h2>Privacy Policy</h2>
      
      <h3>Introduction</h3>
      <p>This document governs the privacy policy of the application <b>Ludico</b> (hereinafter "Application"). This textual content is intended to provide the User with information regarding the processing of Personal Data in compliance with Regulation (EU) 2016/679 ("GDPR") and the ePrivacy Directive.</p>
      
      <h3>Data Controller</h3>
      <p>
        Data Controller: <b>Alberto Boffi</b><br/><br/>
        Tax Code (Codice Fiscale): <b>BFFLRT99M15C933V</b><br/><br/>
        Contact email: <b>astudio.magicreality@gmail.com</b>
      </p>

      <h3>Types of Data Collected and Legal Basis</h3>
      <p>
        The Application collects Usage Data and Tracking Technologies (Cookies) managed by third parties.<br/><br/>
        <b>Usage Data</b>: IP address, URI addresses, time of request, and other parameters regarding the operating system and computer environment. This data is processed automatically for the technical operation of the Application (Legal Basis: Legitimate Interest, Art. 6(1)(f) GDPR).<br/><br/>
        <b>Analytics Data</b>: Aggregated statistics (Google Analytics 4). This data is processed only subject to the User's explicit consent (Legal Basis: Consent, Art. 6(1)(a) GDPR).
      </p>

      <h3>Data Processing and Data Retention</h3>
      <p>
        Data processing is carried out using IT tools. The Controller has implemented appropriate security measures to prevent unauthorized access.<br/><br/>
        <b>Retention Periods</b>: Detailed event data is retained for <b>2 months</b>. User-level data is retained for <b>14 months</b>. Session data is temporary and not stored persistently.<br/><br/>
        Personal Data is processed at the Controller's operating offices and in any other places where the parties involved in the processing are located.
      </p>

      <h3>Data Sharing and International Transfers</h3>
      <p>
        The Application uses Google Analytics 4 and Google Fonts, provided by Google Ireland Limited / Google LLC. This may involve the transfer of data to the United States.<br/><br/>
        Such transfers are based on the standard contractual clauses (SCCs) approved by the European Commission or the EU-US Data Privacy Framework, ensuring an adequate level of protection for Personal Data.
      </p>

      <h3>Rights of the User</h3>
      <p>
        Users may exercise certain rights regarding their Data processed by the Controller (Arts. 15-22 GDPR).<br/><br/>
        In particular, Users have the right to do the following: withdraw consent at any time; object to processing of their Data; access their Data; verify and seek rectification; restrict the processing of their Data; have their Personal Data deleted or otherwise removed; receive their Data and have it transferred to another controller.<br/><br/>
        <b>To exercise these rights, Users may direct a request to the Controller at the contact details provided in this document.</b> These requests can be exercised free of charge and will be addressed by the Controller as early as possible and always within one month.<br/><br/>
        Users have the right to lodge a complaint with their competent data protection authority (in Italy, the "Garante per la protezione dei dati personali").
      </p>

      <h3>Changes to This Privacy Policy</h3>
      <p>The Controller reserves the right to make changes to this privacy policy at any time by notifying its Users on this page and possibly within the Application. It is strongly recommended to check this page often, referring to the date of the last modification listed at the top.</p>
    </section>

    <div class="separator"></div>

    <section id="cookie-policy">
      <h2>Cookie Policy</h2>

      <h3>Cookie Usage</h3>
      <p>
        This Application uses Cookies.<br/><br/>
        <b>Technical Cookies</b>: Strictly necessary for the functioning of the Application and to save the User's tracking preferences (e.g., the consent banner choice). Prior consent is not required for these identifiers.<br/><br/>
        <b>Analytics Cookies</b>: The Application uses Google Analytics 4 with IP anonymization and Consent Mode v2 enabled. These cookies are installed only if the User grants explicit consent via the banner.
      </p>

      <h3>Managing Preferences and Consent</h3>
      <p>Users can manage their preferences related to Cookies directly via their own browser settings (by clearing cookies for this domain, which will reset the consent choice). Disabling all cookies may affect the functioning of the Application (e.g., consent status persistence).</p>

      <h3>Third Party Cookies Information</h3>
      <p>Since the installation of third-party Cookies and other tracking systems through the services used within this Application cannot be technically controlled by the Controller, any specific references to Cookies and tracking systems installed by third parties are to be considered indicative. For complete information, the User is kindly requested to consult the privacy policy of the respective third-party services (Google Analytics, Google Fonts).</p>
    </section>

  </main>

</div>